//#region Libraries
//#endregion
//#region Styles
import {
    Container, 
    Title } from "../../../styles";
import {
    Content, 
    FieldsGroup } from "./styles";    
//#endregion
//#region Components
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import { Row } from "components/styles";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
//#endregion
//#region Utils
import { handlerKeyPressOnlyNumbersAndLetters } from "utils/validations";
//#endregion

const LocationPlaceStep2InCampus = ({
    form, errors, 
    changeField, as,
    isVirtual = false
}) => {
    const { envName, address, floor } = form;
    //#region States
    //#endregion
    //#region Functions
    const changeEnvironmentName = value => {
        changeField("envName", value, false);
    }
    const changeEnvironmentFloor = value => {
        changeField("floor", value, false);
    }
    //#endregion
    const location = useLocation();
    const isEmployability = useMemo(
        () => location.pathname.includes("/asesorias/empleabilidad/crear")
    , [location]);
    return (
        <Container>
            <Title>Paso 02:</Title>
            <Content>
                <section>
                    <h4>Dentro del Campus UTP</h4>
                    <FieldsGroup width="100%">
                        <Row minWidth="200px" maxWidth="500px">
                            <CustomTextInput
                                label="Ambiente"
                                value={envName}
                                onChange={changeEnvironmentName}
                                placeholder={isEmployability ? "Ejemplo: Cancha 1" : "Ejemplo: Cancha 1 Innova School"}
                                maxLength={250}
                                error={errors.envName}
                                disabled={isVirtual}
                                errorText={`Escribe el ambiente para el ${as}`}/>
                            <CustomTextInput
                                label="Dirección"
                                value={address}
                                placeholder="Dirección del ambiente"
                                disabled/>
                            <CustomTextInput
                                label="Piso"
                                value={floor}
                                onChange={changeEnvironmentFloor}
                                onKeyPress={handlerKeyPressOnlyNumbersAndLetters}
                                placeholder={isEmployability ? "Ejemplo: Piso 2" :"Agregar piso"}
                                maxLength={100}
                                error={errors.floor}
                                disabled={isVirtual}
                                errorText={`Escribe el piso para el ${as}`}/>
                        </Row>
                    </FieldsGroup>
                </section>
            </Content>
        </Container>
    );
}

export default LocationPlaceStep2InCampus;
